import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/UllrWeb/UllrWeb/app/components/datadog-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/UllrWeb/UllrWeb/app/components/fathom-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/UllrWeb/UllrWeb/app/lib/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/UllrWeb/UllrWeb/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/UllrWeb/UllrWeb/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\",\"variable\":\"--font-roboto\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/UllrWeb/UllrWeb/app/globals.css");
